<template>
	<div class="head" :style="{ color: fontColor == '' ? '#FFF' : fontColor }">
		<div>
			<!-- <img class="isNews" v-if="tabNavIndex == 4" src="@/assets/image/big_version/logo.png" /> -->
			<img :src="`${logoImg == '' ? require('@/assets/image/logo/notColorLogo.png') : logoImg}`" />
			<div>
				<div>
					<span class="logo_span">{{ title }}</span>
					<!-- <span class="logo_span">·</span> -->
					<!-- <span class="logo_span">智慧教育平台</span> -->
				</div>
				<div>CHANG DU ONLINE</div>
			</div>
		</div>
		<!-- 上边是logo -->
		<ul>
			<li v-for="nav in tabNav" @click="toNav(nav.index)" :class="{ active: headerNavIndex == nav.index }">
				{{ nav.lable }}
			</li>
			<li class="login_btn" v-if="show">
				<span @click="toLogin()">登录</span>
				<span>|</span>
				<span @click="toRegist()">注册</span>
			</li>
			<li class="login_btn" v-else>
				<span @click="toInfo">{{ name }}</span>
				<span>|</span>
				<span @click="logout">退出</span>
			</li>
			<!-- <li class="login_on" v-else>
				<img :src="avatar" />
				<span>{{ name }}</span>
			</li> -->
		</ul>
	</div>
</template>

<script>
// 
import { MesssageBoxQuestion } from '@/components/util/MessageBox'
export default {
	// 接收父组件传参
	props: {
		logoImg: {
			type: String,
			default: ''
		},
		fontColor: {
			type: String,
			default: ''
		},
		tabNavIndex: {
			type: Number,
			default: null
		}
	},
	data() {
		return {
			title: process.env.VUE_APP_TITLE,
			headerNavIndex: this.tabNavIndex,
			show: true,
			tabNav: [
				{ lable: '首页', index: 1 },
				{ lable: '学习中心', index: 2 },
				{ lable: '课程中心', index: 3 },
				{ lable: '新闻中心', index: 4 },
				{ lable: '关于我们', index: 5 },
				// { lable: '购物车', index: 7 },
				// { lable: '资料库', index: 6 },
			],
			name: '',
			avatar: ''
		}
	},
	mounted() {
		let id = this.$store.state.user.userid
		if (id) {
			this.show = false
			this.name = this.$store.state.user.name
			this.avatar = this.$store.state.user.avatar
		}
	},
	methods: {
		toNav(arg) {
			switch (arg) {
				case 1:
					this.$router.push({ path: '/' }).catch(() => { })
					break;
				case 2:
					// if(this.name){
						this.$router.push({ path: '/study' }).catch(() => { })
					// }else {
					// 	MesssageBoxQuestion('您还没有登录，请先去登录').then(() => {
					// 		this.$router.push({ path: '/login' }).catch(() => { })
					// 	}).catch(err => {})
					// }
					break;
				case 3:
					this.$router.push({ path: '/courseList' }).catch(() => { })
					break;
				case 4:
					this.$router.push({ path: '/news' }).catch(() => { })
					break;
				case 5:
					// window.location.href = 'http://124.223.46.108'
					this.$router.push({ path: '/about' }).catch(() => { })
					break;
				case 6:
					this.$router.push({ path: '/dataBaseMain' }).catch(() => {})
					break;
				case 7:
					this.$router.push({ path: '/cart' }).catch(() => {})
					break;
				default:
			}
		},
		// 登录
		toLogin() {
			this.$router.push({
				path: '/login'
			}).catch(() => { })
		},
		// 注册
		toRegist(){
			this.$router.push({ path: '/regist'}).catch(() => {})
		},
		// 退出登录
		logout(){
			this.$store.commit('RESET_STATE')
			window.location.reload()
		},
		toInfo(){
			this.$router.push({ path: '/userInfo'}).catch(() => {})
		}
	}
}
</script>

<style scoped lang="scss">
.head {
	height: 120px;
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;

	&>div {
		display: flex;
		align-items: center;

		&>img {
			height: 90px;
			margin-left: 40px;
		}

		&>div {
			margin-left: -10px;

			&>div:nth-child(1) {
				display: flex;
				align-items: center;

				&>.logo_span {
					display: block;
					font-weight: 500;
					font-size: 36px;
					margin-top: 24px;
					margin-left: 10px;
					text-wrap: nowrap;
				}
			}

			&>div:nth-child(2) {
				display: block;
				font-weight: 500;
				font-size: 14px;
				margin-left: 10px;
			}
		}
	}




	&>ul {
		display: flex;

		&>li {
			margin-right: 40px;
			font-weight: 500;
			font-size: 22px;
			display: flex;
			justify-content: center;
			align-items: center;
			text-wrap: nowrap;

			&:hover:not(:last-child) {
				cursor: pointer;
			}
		}

		&>.active {
			border-bottom: 3px #EB690A solid;
		}

		&>.login_btn {
			font-weight: 400;
			font-size: 16px;
			padding: 10px 20px;
			color: #FFF;
			background: #EF4A10;
			border-radius: 38px;

			&>span:last-child:hover,
			&>span:first-child:hover {
				cursor: pointer;
			}

			&>span:first-child {
				padding-right: 10px;
			}

			&>span:last-child {
				padding-left: 10px;
			}
		}

		&>.login_on {
			display: flex;
			flex-direction: column;
			justify-content: center;

			&>img {
				width: 40px;
				height: 40px;
				border-radius: 20px;
			}

			&>span {
				font-size: 16px;
			}
		}
	}
}
</style>